import React from 'react'
import ProfilePic from "../Assets/john-doe-image.png";
import { AiFillStar } from "react-icons/ai";

function Testimonial() {
  return (
    <div className='work-section-wrapper'>
        <div className='work-section-top'>
            <p className='primary-subheading'>Maak Kennis</p>
            <h1 className='primary-heading'>Chefkok van de Week</h1>
            <p className="primary-text">
            "Ik ben Michiel Ruitbeek, chefkok in een Michellin Sterrenrestaurant in hartje Amsterdam. Ik ben gespecialiseerd in de Franse keuken en heb een passie voor het bereiden van visgerechten. Ik ben altijd op zoek naar nieuwe smaken en combinaties om mijn gasten te verrassen."
        </p>
        </div>
        <div className='testimonial-section-bottom'>
            <img src={ProfilePic} alt=''></img>
            <div className='testimonial-starts-container'>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
            </div>
            <h2>Michiel Ruitbeek</h2>
        </div>
    </div>
  )
}

export default Testimonial